var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('NavBar',{attrs:{"loginPage":true}}),_c('v-main',[_c('LoginForm',{attrs:{"afterRegistration":_vm.afterRegistration,"provider":_vm.provider}})],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }